"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("./Types");
function rgbsArg(rgbs) {
    if (typeof rgbs === 'string' && rgbs.length > 0) {
        return { rgbs: rgbs };
    }
    else if (Array.isArray(rgbs) && rgbs.length > 0 && typeof rgbs[0] === 'string') {
        return { rgbs: rgbs.join('|') };
    }
    else if (Types_1.isRgbItemList(rgbs)) {
        return { rgbs: rgbs.map(function (_a) {
                var r = _a.r, g = _a.g, b = _a.b;
                return r + "," + g + "," + b;
            }).join('|') };
    }
    else {
        return {};
    }
}
exports.rgbsArg = rgbsArg;
function yarnsArg(yarns) {
    if (yarns && Array.isArray(yarns) && yarns.length > 0) {
        return { yarns: yarns.join(',') };
    }
    else if (typeof yarns === 'string' && yarns.length > 0) {
        return { yarns: yarns };
    }
    else {
        return {};
    }
}
function mutedIndicesArg(mutedIndices) {
    if (mutedIndices && Array.isArray(mutedIndices) && mutedIndices.length > 0) {
        return { muted: mutedIndices.join(',') };
    }
    else {
        return {};
    }
}
function parseArg(key, value) {
    if (value) {
        return _a = {}, _a[key] = "" + value, _a;
    }
    else {
        return {};
    }
    var _a;
}
exports.parseArg = parseArg;
function recolor(_a) {
    var yarns = _a.yarns, mutedIndices = _a.mutedIndices, rgbs = _a.rgbs, refColor = _a.refColor, refLibs = _a.refLibs, texture = _a.texture, clutColorwayId = _a.clutColorwayId;
    if (!yarns && !rgbs && !clutColorwayId) {
        throw new Error('A list of yarn codes or rgbs must be provided for recoloring.');
    }
    return __assign({}, rgbsArg(rgbs), yarnsArg(yarns), mutedIndicesArg(mutedIndices), parseArg('refColor', refColor), parseArg('refLibs', refLibs), parseArg('texture', texture), parseArg('clutColorwayId', clutColorwayId));
}
exports.recolor = recolor;
function rug(_a) {
    var designs = _a.designs, sections = _a.sections, pal = _a.pal, pos = _a.pos, scales = _a.scales, texture = _a.texture, pixels = _a.pixels;
    return __assign({ designs: designs.join(','), sections: sections.join(','), pal: pal.join(','), pos: (function () {
            var items = [];
            for (var i = 0; i < pos.length; i++) {
                items.push(pos[i].join(','));
            }
            return items.join('|');
        })(), scales: scales.join(',') }, parseArg('texture', texture), parseArg('pixels', pixels));
}
exports.rug = rug;
function areaRug(_a) {
    var physWidth = _a.physWidth, physHeight = _a.physHeight, installId = _a.installId, sergeColor = _a.sergeColor, sergeType = _a.sergeType, shape = _a.shape, rotation = _a.rotation, pixels = _a.pixels;
    return __assign({}, parseArg('physWidth', physWidth), parseArg('physHeight', physHeight), parseArg('installId', installId), parseArg('sergeColor', sergeColor), parseArg('sergeType', sergeType), parseArg('shape', shape), parseArg('rotation', rotation), parseArg('pixels', pixels));
}
exports.areaRug = areaRug;
